export const createGeoJSONFileFromFeatures = (features?: GeoJSON.Feature[] | null) => {
  if (!features || features.length === 0) return null

  const featureCollection: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features,
  }

  return new File([JSON.stringify(featureCollection)], 'new-project.geojson', {
    type: 'application/json',
  })
}
